function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 24 19 L 2 19 C 1.969 19.029 1.989 17.005 2 17 L 2 7 C 2 5.895 2.895 5 4 5 L 24 5 C 23.993 6.975 24.013 17.011 24 19",
    style: {
      fill: "rgba(0, 0, 0, 0.37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24 19.5 L 4 19.5 C 3.345 19.478 2.657 19.193 2.232 18.768 C 1.807 18.343 1.522 17.655 1.5 17 L 1.5 7 C 1.522 6.345 1.807 5.657 2.232 5.232 C 2.657 4.807 3.345 4.522 4 4.5 L 24.502 4.5 L 24.5 5.002 C 24.499 5.211 24.499 5.511 24.499 5.883 L 24.5 5.882 L 24.5 9.346 C 24.501 10.192 24.502 11.093 24.502 11.994 C 24.504 13.497 24.505 15 24.505 16.251 C 24.504 17.503 24.5 19 24.5 19 C 24.5 19 24.25 19 24 19 Z M 23.499 5.5 L 4 5.5 C 3.55 5.478 3.238 5.64 2.939 5.939 C 2.64 6.238 2.478 6.55 2.5 7 L 2.5 17 C 2.478 17.45 2.64 17.762 2.939 18.061 C 3.238 18.36 3.55 18.522 4 18.5 L 23.501 18.5 C 23.502 18.234 23.503 17.883 23.503 17.5 L 4 17.5 L 3.985 16.5 L 23.5 15.9 L 23.5 9.349 C 23.5 8.913 23.499 8.503 23.499 8.119 L 23.431 8.18 L 22.765 7.434 L 23.498 6.778 C 23.498 6.284 23.498 5.857 23.499 5.5 Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(3, 3, 3)",
      fontFamily: "Roboto",
      fontSize: 7,
      whiteSpace: "pre"
    },
    x: 8.308,
    y: 14.615
  }, "Lab."), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 2
    },
    x1: 2.003,
    y1: 18.488,
    x2: 24,
    y2: 18.488
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilled);
export default __webpack_public_path__ + "static/media/filled.270be03672c2c9f163ccab6f2796dd24.svg";
export { ForwardRef as ReactComponent };